import React from "react";
import "./home.css";
import { NavLink } from "react-router-dom";

function Home() {
  return (
    <div>
      <div id="home" className="hero-area">
        <div className="container">
          <div className="row">
            <div className="col-md-7">
              <div className="hero-content">
                <p data-aos="fade-in" data-aos-duration={1000}>
                  Hello, I’m
                </p>
                <h1 data-aos="fade-in" data-aos-duration={2000}>
                  Mac Prince
                </h1>
                <h2 data-aos="fade-in" data-aos-duration={3000}>
                  Full-Stack Developer
                </h2>
                <span
                  className="sign"
                  data-aos="fade-in"
                  data-aos-duration={3000}
                >
                  portfolio
                </span>
              </div>
            </div>
            <div className="col-md-5">
              <div
                className="hero-img"
                data-aos="fade-left"
                data-aos-duration={3000}
              >
                <img src="assets/img/hero/face_cut.png" alt title="portfolio" />
                {/* <img src="assets/img/hero/hero1-mahmud.png" alt title="portfolio" /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="about" className="about">
        <div className="container">
          <div className="row">
            <div className="col-md-5 order-2 order-md-1">
              <div
                className="about-img card-s"
                data-aos="fade-right"
                data-aos-duration={3000}
              >
                <img src="assets/img/hero/side.jpg" alt title="portfolio" />
              </div>
            </div>
            <div className="col-md-7 order-1 order-md-2">
              <div className="about-content">
                <nav>
                  <div
                    className="nav nav-tabs nav-fill"
                    id="nav-tab"
                    role="tablist"
                  >
                    <a
                      className="nav-item nav-link active"
                      id="nav-about-tab"
                      data-toggle="tab"
                      href="#nav-about"
                      role="tab"
                      aria-controls="nav-about"
                      aria-selected="true"
                    >
                      About
                    </a>
                    <a
                      className="nav-item nav-link"
                      id="nav-skills-tab"
                      data-toggle="tab"
                      href="#nav-skills"
                      role="tab"
                      aria-controls="nav-skills"
                      aria-selected="false"
                    >
                      Skills
                    </a>
                    {/* <a
                        className="nav-item nav-link"
                        id="nav-interview-tab"
                        data-toggle="tab"
                        href="#nav-interview"
                        role="tab"
                        aria-selected="false"
                      >
                        Interview
                      </a> */}
                  </div>
                </nav>
                <div
                  className="tab-content py-3 px-3 px-sm-0"
                  id="nav-tabContent"
                >
                  <div
                    className="tab-pane fade show active"
                    id="nav-about"
                    role="tabpanel"
                    aria-labelledby="nav-about-tab"
                  >
                    <div className="about-single-content">
                      <h2>About Me</h2>
                      <p>
                        <strong>Hello! I'm Mac Prince,</strong>
                      </p>
                      <p>
                        A <strong>FullStack and a Wordpress Developer.</strong>{" "}
                        With over 3 years of experience delivering fast and
                        responsive websites. I specialize in both
                        custom-coded and CMS-driven websites, helping businesses
                        establish a strong online presence. <hr />
                        <p>
                          <strong>Tech Stack</strong>
                        </p>
                        HTML, CSS, JavaScript, React.js, Node.js, and MongoDB.
                        <p>
                          <strong>WordPress Expertise</strong>
                        </p>
                        Theme customization (custom or marketplace themes),
                        Elementor & page builder design, WooCommerce setup &
                        product integration, Plugin configuration, Speed
                        optimization & mobile responsiveness.
                        <p>
                          {" "}
                          <hr />I am excited about the opportunity to bring my
                          expertise to your team and contribute to your
                          projects.{" "}
                          <strong className="strong">
                            {" "}
                            Feel free to reach out
                          </strong>
                          , and let’s bring your digital project to life!
                        </p>
                        {/* <p>
                          {" "}
                          In addition to my technical skills, I am also a
                          passionate content creator and a successful freelancer
                          on platforms like Fiverr and Upwork. My commitment to
                          delivering high-quality work and ensuring complete
                          client satisfaction sets me apart. I pride myself on
                          my ability to provide efficient solutions and perform
                          revisions until the final product aligns perfectly
                          with your vision. Whether you're looking to develop a
                          new website, enhance an existing one, or create a
                          robust application, I am here to help you achieve your
                          goals with precision and professionalism. Feel free to
                          reach out, and let’s bring your digital project to
                          life!
                        </p> */}
                      </p>
                      <a
                        href="https://wa.me/2349056789309"
                        className="btn-1 btn-h"
                      >
                        Let's Chat
                      </a>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="nav-skills"
                    role="tabpanel"
                    aria-labelledby="nav-skills-tab"
                  >
                    <div className="about-single-content">
                      <h2>My Skills</h2>
                      <h5>HTML</h5>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          aria-valuenow={60}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ maxWidth: "100%" }}
                        >
                          <span className="title">100%</span>
                        </div>
                      </div>
                      <h5>CSS</h5>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          aria-valuenow={60}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ maxWidth: "95%" }}
                        >
                          <span className="title">95%</span>
                        </div>
                      </div>
                      <h5>Javascript</h5>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          aria-valuenow={60}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ maxWidth: "80%" }}
                        >
                          <span className="title">80%</span>
                        </div>
                      </div>
                      <h5>React JS</h5>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          aria-valuenow={60}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ maxWidth: "87%" }}
                        >
                          <span className="title">87%</span>
                        </div>
                      </div>
                      <h5>NodeJS</h5>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          aria-valuenow={60}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ maxWidth: "75%" }}
                        >
                          <span className="title">75%</span>
                        </div>
                      </div>
                      <h5>ExpressJS</h5>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          aria-valuenow={60}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ maxWidth: "75%" }}
                        >
                          <span className="title">75%</span>
                        </div>
                      </div>
                      <h5>Mongo DB</h5>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          aria-valuenow={60}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ maxWidth: "90%" }}
                        >
                          <span className="title">90%</span>
                        </div>
                      </div>
                      <h5>WordPress Development</h5>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          aria-valuenow={60}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ maxWidth: "95%" }}
                        >
                          <span className="title">95%</span>
                        </div>
                      </div>
                      <h5>Elementor</h5>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          aria-valuenow={60}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ maxWidth: "98%" }}
                        >
                          <span className="title">98%</span>
                        </div>
                      </div>
                      <h5>WooCommerce setup & product integration</h5>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          aria-valuenow={60}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ maxWidth: "97%" }}
                        >
                          <span className="title">97%</span>
                        </div>
                      </div>
                      <h5>Plugin configuration</h5>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          aria-valuenow={60}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ maxWidth: "95%" }}
                        >
                          <span className="title">95%</span>
                        </div>
                      </div>
                      <h5>Speed optimization</h5>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          aria-valuenow={60}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ maxWidth: "95%" }}
                        >
                          <span className="title">95%</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="service" className="service">
        <h2 data-aos="fade-up" data-aos-duration={3000}>
          Awesome Service
        </h2>
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <NavLink to="#">
                <div
                  className="single-service card-s"
                  data-aos="fade-up"
                  data-aos-duration={3000}
                >
                  <div className="icon">
                    <i className="flaticon-visual" />
                  </div>
                  <div className="content">
                    <h3>Corporate Websites</h3>
                    <p>
                      I will build a clean corporate website to represent your
                      business
                    </p>
                  </div>
                </div>
              </NavLink>
            </div>
            <div className="col-md-4">
              <NavLink to="#">
                <div
                  className="single-service card-s"
                  data-aos="fade-up"
                  data-aos-duration={3000}
                >
                  <div className="icon">
                    <i className="flaticon-products" />
                  </div>
                  <div className="content">
                    <h3>Ecommerce Store</h3>
                    <p>
                      I will create a fast WooCommerce website to sell your
                      products
                    </p>
                  </div>
                </div>
              </NavLink>
            </div>
            <div className="col-md-4">
              <div
                className="single-service card-s"
                data-aos="fade-up"
                data-aos-duration={3000}
              >
                <div className="icon">
                  <i className="flaticon-web-development" />
                </div>
                <div className="content">
                  <h3>Frontend Dev</h3>
                  <p>
                    I specialize in frontend dev, crafting interactive user
                    interfaces!
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div
                className="single-service card-s"
                data-aos="fade-up"
                data-aos-duration={3000}
              >
                <div className="icon">
                  <i className="flaticon-web-development" />
                </div>
                <div className="content">
                  <h3>Web Development</h3>
                  <p>
                    I provide expert web development services to build scalable
                    websites for your needs!
                  </p>
                </div>
              </div>
            </div>
            {/* <div className="col-md-4">
              <div
                className="single-service card-s"
                data-aos="fade-up"
                data-aos-duration={3000}
              >
                <div className="icon">
                  <i className="flaticon-article" />
                </div>
                <div className="content">
                  <h3>WordPress Design</h3>
                  <p>
                    I design custom WordPress websites that engage users and
                    elevate your brand online.
                  </p>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <div id="portfolio" className="portfolio">
        <div className="container">
          <h2 className="text-left" data-aos="fade-up" data-aos-duration={3000}>
            My Latest Project
          </h2>
          <div className="row">
            <div className="col-md-4">
              <div
                className="single-portfolio card-s"
                data-aos="fade-up"
                data-aos-duration={3000}
              >
                <img
                  src="assets/img/portfolio/mehomagroceries.png"
                  alt
                  title="portfolio"
                />
                <div className="sp-text">
                  <h6>Wordpress Design</h6>
                  <h3>E-Commerce</h3>
                  <a href="http://mehomagroceries.com/" className="btn-2">
                    View Demo
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div
                className="single-portfolio card-s"
                data-aos="fade-up"
                data-aos-duration={3000}
              >
                <img
                  src="assets/img/portfolio/Minimalist Neutral Multi Device Computer Mockup Website Launch Instagram Po_20241002_084804_0000.png"
                  alt
                  title="portfolio"
                />
                <div className="sp-text">
                  <h6>MERN Stack</h6>
                  <h3>Business Website</h3>
                  <a
                    href="https://next-tourist-destination.vercel.app/"
                    className="btn-2"
                  >
                    View Demo
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div
                className="single-portfolio card-s"
                data-aos="fade-up"
                data-aos-duration={3000}
              >
                <img
                  src="assets/img/portfolio/port.png"
                  alt
                  title="portfolio"
                />
                <div className="sp-text">
                  <h6>Personal &amp; Portfolio</h6>
                  <h3>Portfolio Website</h3>
                  <a
                    href="https://photography-5k4e.vercel.app/"
                    className="btn-2"
                  >
                    View Demo
                  </a>
                </div>
              </div>
            </div>
          </div>
          <NavLink to="portfolio" className="btn-1 btn-h">
            View More
          </NavLink>
        </div>
      </div>
      <div id="blog" className="blog">
        <h2 data-aos="fade-up" data-aos-duration={3000}>
          Latest Youtube Videos
        </h2>
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <div
                className="single-blog card-s"
                data-aos="fade-up"
                data-aos-duration={3000}
              >
                <div className="sb-img">
                  <img src="assets/img/blog/upwork.jpg" alt title="portfolio" />
                </div>
                <div className="sb-text">
                  <a href>
                    <h3>
                      Upwork Introduction Vide: Mac Prince (Full Stack
                      Developer)
                    </h3>
                  </a>
                  <a href="https://youtu.be/Xa_edqm8cYY" className="btn-2">
                    Watch Video
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div
                className="single-blog card-s"
                data-aos="fade-up"
                data-aos-duration={3000}
              >
                <div className="sb-img">
                  <img
                    src="assets/img/blog/wordpress.png"
                    alt
                    title="portfolio"
                  />
                </div>
                <div className="sb-text">
                  <a href>
                    <h3>
                      Wordpress VS Coding: My Experience using both as a
                      freelancer
                    </h3>
                  </a>
                  <a href="https://youtu.be/MHDhueT1zWE" className="btn-2">
                    Watch Video
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div
                className="single-blog card-s"
                data-aos="fade-up"
                data-aos-duration={3000}
              >
                <div className="sb-img">
                  <img
                    src="assets/img/blog/frontend.png"
                    alt
                    title="portfolio"
                  />
                </div>
                <div className="sb-text">
                  <a href>
                    <h3>
                      Frontend, Backend and Full Stack Development Explained
                    </h3>
                  </a>
                  <a href="https://youtu.be/-J3nF1bGgIs" className="btn-2">
                    Watch Video
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="contact" className="hire">
        <div className="container">
          <div className="hire-details">
            <h2>Hire Me.</h2>
            <div className="hire-info">
              <form
                action="mailto:macprince.dev@gmail.com"
                method="post"
                enctype="text/plain"
              >
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    id="name"
                    placeholder="Your Name"
                    onfocus="this.placeholder = ''"
                    onblur="this.placeholder ='Your Name'"
                  />
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    name="email"
                    id="email"
                    placeholder="Your Email"
                    onfocus="this.placeholder = ''"
                    onblur="this.placeholder ='Your Email'"
                  />
                </div>
                <div className="form-group">
                  <textarea
                    rows={4}
                    className="form-control"
                    name="msg"
                    id="msg"
                    placeholder="Speak Your Mind"
                    onfocus="this.placeholder =''"
                    onblur="this.placeholder ='Speak Your Mind'"
                    defaultValue={""}
                  />
                </div>
                <button type="submit" id="submit" className="btn-1 btn-h">
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
